export default __webpack_public_path__ + "static/media/best_wallet_with_border.828e3a6c.svg";